// 一些通用的方法

/**
 * 下载文件
 * @param {File} file 文件
 * @param {String} filename 文件名
 */
export function downloadFile(file, filename) {
  const a = document.createElement('a')
  a.download = filename
  a.style.display = 'none'
  a.href = URL.createObjectURL(file)
  document.body.appendChild(a)
  a.click()
  URL.revokeObjectURL(a.href)
  document.body.removeChild(a)
}

// 清除登录信息
export function clearLoginInfo() {
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('userId')
  sessionStorage.removeItem('userName')
  sessionStorage.removeItem('userAvatar')
}

// 设置网站标题
export function setWebTitle(title) {
  document.title = title
}

// 设置页面背景色
export function setPageBg(color) {
  document.body.setAttribute('style', `background: ${color}`)
}

// 移除页面背景色
export function removePageBg() {
  document.body.removeAttribute('style')
}